import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CFormGroup,
  CLabel,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CSpinner,
  CSelect,
  CInput,
  CRow,
  CCol,
  CBadge,
  CAlert
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Prompt } from "react-router-dom";
import Select from "react-select";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import CommunityUsersSelector from "../../../../components/CommunityUsersSelector";
import {
  alphaNumeric,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class ClassroomMigration extends Component {
  constructor(props) {
    super(props);

    // Mapeamento das disciplinas padrão por série (mesmo da criação)
    this.defaultDisciplinesBySerie = {
      5: [18, 1, 35],
      6: [18, 1, 35],
      1: [24, 25, 26, 27, 28],
      2: [24, 25, 26, 27, 28],
      3: [24, 25, 26, 27, 28],
      4: [24, 25, 26, 27, 28],
      7: [1, 5, 8, 9, 10],
      8: [1, 5, 8, 9, 10],
      9: [1, 5, 8, 9, 10],
      10: [1, 5, 8, 9, 10],
      11: [1, 5, 8, 9, 10],
      12: [1, 5, 8, 9, 10],
      13: [1, 5, 8, 9, 10],
      14: [1, 5, 8, 9, 10],
      15: [1, 5, 8, 9, 10],
      16: [1, 5, 8, 9, 3, 2, 4, 12, 7, 13, 11],
      17: [1, 5, 8, 9, 3, 2, 4, 12, 7, 13, 11],
      18: [1, 5, 8, 9, 3, 2, 4, 12, 7, 13, 11],
      19: [1, 5, 8, 9, 3, 2, 4, 12, 7, 13, 11]
    };

    this.state = {
      loading: false,
      originalRoom: null,
      optionsGroup: [{ value: null, name: "Carregando" }],
      optionsRegion: [{ value: null, name: "Carregando" }],
      optionsSchool: [{ value: null, name: "Carregando" }],
      optionsPeriod: [{ value: null, name: "Carregando" }],
      group_id: null,
      region_id: null,
      school_id: null,
      selectedDisciplines: [],
      disciplines: [],
      series: [],
      creating: false,
      customForm: {
        name: "",
        period_id: "",
        start: "",
        end: ""
      },
      isReviewMode: false,
      selectedSerie: null,
      defaultDisciplines: [],
      // Novos states específicos para migração
      migrationChanges: {
        originalYear: "",
        newYear: "",
        originalSeries: [],
        migratedSeries: []
      },

      roomUsers: [],
      loadingUsers: false,
      removingUser: null
    };
    this.formRef = React.createRef();
    this.customFormRef = React.createRef();
    this.enviar = this.enviar.bind(this);
    this.removeUserFromRoom = this.removeUserFromRoom.bind(this);
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    // Carrega dados básicos (grupo, região, escola, período, séries, disciplinas)
    this.loadBasicData();

    // Carrega os dados da turma original para migração
    const { id } = this.props.match.params;
    if (id) {
      this.loadOriginalRoomData(id);
    }
  }

  loadBasicData() {
    // Carrega grupos
    axios
      .get(`${URL.api}access/group/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respGroup => {
          const optionsGroup = respGroup.data.data.map(group => ({
            value: group.id,
            name: group.name
          }));
          this.setState({ optionsGroup });
        },
        error => this.error(error.response.statusText)
      );

    // Carrega regionais
    axios
      .get(`${URL.api}access/region/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respRegion => {
          const optionsRegion = respRegion.data.data.map(region => ({
            value: region.id,
            name: region.name,
            group_id: region.group_id
          }));
          this.setState({ optionsRegion });
        },
        error => this.error(error.response.statusText)
      );

    // Carrega escolas
    axios
      .get(`${URL.api}access/school/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respSchool => {
          const optionsSchool = respSchool.data.data.map(school => ({
            value: school.id,
            name: school.name,
            region_id: school.region_id
          }));
          this.setState({ optionsSchool });
        },
        error => this.error(error.response.statusText)
      );

    // Carrega períodos
    axios
      .get(`${URL.api}community/period/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respPeriod => {
          this.setState({
            optionsPeriod: respPeriod.data.data.map(period => ({
              value: period.id,
              name: period.name
            }))
          });
        },
        error => this.error(error.response.statusText)
      );

    // Carrega séries
    axios
      .get(`${URL.api}classification/serie/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respSeries => {
          this.setState({
            series: respSeries.data.data.map(serie => ({
              value: serie.id,
              label: serie.name
            }))
          });
        },
        error => this.error(error.response.statusText)
      );

    // Carrega disciplinas
    axios
      .get(`${URL.api}classification/discipline/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respDisciplines => {
          this.setState({
            disciplines: respDisciplines.data.data.map(serie => ({
              value: serie.id,
              label: serie.name
            }))
          });
        },
        error => this.error(error.response.statusText)
      );
  }

  loadOriginalRoomData(roomId) {
    this.setState({ loading: true }, () => {
      axios
        .get(`${URL.api}community/room/singleView/${roomId}`, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          if (resp.data.success) {
            const roomData = resp.data.data.room;

            const roomUsers = resp.data.data.room_user || [];
            this.processOriginalRoomData(
              roomData,
              resp.data.data.room_discipline,
              roomUsers
            );
          }
        })
        .catch(error => {
          this.error(error.response?.statusText || "Erro ao carregar turma");
          this.setState({ loading: false });
        });
    });
  }

  processOriginalRoomData(roomData, roomDisciplines, roomUsers) {
    // Extrai ano da data de início da turma original
    const originalStartDate = new Date(roomData.start);
    const originalYear = originalStartDate.getFullYear();

    // Usa o método auxiliar para determinar o ano de destino
    const targetYear = this.getTargetMigrationYear(originalYear);

    // Calcula datas para o ano de destino
    const newStartDate = new Date(originalStartDate);
    newStartDate.setFullYear(targetYear);

    const originalEndDate = new Date(roomData.end);
    const newEndDate = new Date(originalEndDate);
    newEndDate.setFullYear(targetYear);

    // Processa as disciplinas para encontrar a série principal e migrar para a próxima série
    const processedDisciplines =
      this.processDisciplinesForMigration(roomDisciplines);

    this.setState(
      {
        originalRoom: roomData,
        group_id: roomData.group_id,
        region_id: roomData.region_id,
        school_id: roomData.school_id,
        selectedDisciplines: processedDisciplines.selectedDisciplines,
        selectedSerie: processedDisciplines.selectedSerie,
        customForm: {
          name: roomData.name,
          period_id: roomData.period_id,
          start: newStartDate.toISOString().split("T")[0],
          end: newEndDate.toISOString().split("T")[0]
        },
        migrationChanges: {
          originalYear, // Ano original da turma
          newYear: targetYear, // Ano de destino
          originalSeries: processedDisciplines.originalSeries,
          migratedSeries: processedDisciplines.migratedSeries,
          migrationRule: this.getMigrationRuleDescription(
            originalYear,
            targetYear
          ) // Novo campo
        },
        roomUsers,
        loadingUsers: false,
        loading: false
      },
      () => {
        // Carrega disciplinas padrão para a série migrada
        if (processedDisciplines.selectedSerie) {
          this.loadDefaultDisciplines(processedDisciplines.selectedSerie.value);
        }
      }
    );
  }

  processDisciplinesForMigration(roomDisciplines) {
    if (!roomDisciplines || roomDisciplines.length === 0) {
      return {
        selectedDisciplines: [],
        selectedSerie: null,
        originalSeries: [],
        migratedSeries: []
      };
    }

    // Encontra a série mais frequente (série principal)
    const seriesCount = {};
    roomDisciplines.forEach(item => {
      seriesCount[item.serie_id] = (seriesCount[item.serie_id] || 0) + 1;
    });

    const mainSerieId = parseInt(
      Object.keys(seriesCount).reduce((a, b) =>
        seriesCount[a] > seriesCount[b] ? a : b
      )
    );

    // Encontra a série principal completa
    const mainSerie = this.state.series.find(s => s.value === mainSerieId);

    if (!mainSerie) {
      return {
        selectedDisciplines: [],
        selectedSerie: null,
        originalSeries: [],
        migratedSeries: []
      };
    }

    // Calcula a próxima série baseada no value (ID)
    const nextSerie = this.findNextSerie(mainSerieId);

    const originalSeries = [mainSerie.label];
    const migratedSeries = [nextSerie ? nextSerie.label : "Série final"];

    // Processa as disciplinas para a migração
    const selectedDisciplines = roomDisciplines.map(item => {
      const isFromMainSerie = item.serie_id === mainSerieId;
      let newSerieId = isFromMainSerie
        ? nextSerie
          ? nextSerie.value
          : mainSerieId
        : item.serie_id;

      // Para disciplinas não da série principal, tenta encontrar a próxima série também
      if (!isFromMainSerie) {
        const extraSerie = this.state.series.find(
          s => s.value === item.serie_id
        );
        if (extraSerie) {
          const nextExtraSerie = this.findNextSerie(extraSerie.value);
          if (nextExtraSerie) {
            newSerieId = nextExtraSerie.value;
            if (!originalSeries.includes(extraSerie.label))
              originalSeries.push(extraSerie.label);
            if (!migratedSeries.includes(nextExtraSerie.label))
              migratedSeries.push(nextExtraSerie.label);
          }
        }
      }

      return {
        serie: newSerieId,
        discipline: item.discipline_id,
        isDefault: false // Será recalculado quando carregar as disciplinas padrão
      };
    });

    return {
      selectedDisciplines,
      selectedSerie: nextSerie
        ? {
            value: nextSerie.value,
            label: nextSerie.label
          }
        : { value: mainSerieId, label: mainSerie.label },
      originalSeries,
      migratedSeries
    };
  }

  findNextSerie(currentSerieId) {
    if (!currentSerieId) return null;

    // Encontra todas as séries ordenadas por value (ID)
    const allSeries = [...this.state.series].sort((a, b) => a.value - b.value);

    // Encontra a série atual
    const currentIndex = allSeries.findIndex(s => s.value === currentSerieId);

    if (currentIndex === -1 || currentIndex === allSeries.length - 1) {
      return null; // Não há próxima série
    }

    // Retorna a próxima série na sequência
    return allSeries[currentIndex + 1];
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  // Funções para manipulação de disciplinas (similares à criação)
  handleSerieChange = selectedOption => {
    const serieId = selectedOption ? selectedOption.value : null;
    this.setState(
      state => ({
        selectedSerie: selectedOption,
        selectedDisciplines: []
      }),
      () => {
        if (serieId) {
          this.loadDefaultDisciplines(serieId);
        }
      }
    );
  };

  loadDefaultDisciplines = serieId => {
    if (!serieId) {
      this.setState({ defaultDisciplines: [] });
      return;
    }

    const defaultDisciplineIds = this.defaultDisciplinesBySerie[serieId] || [];

    this.setState(state => {
      const defaultDisciplines = state.disciplines.filter(discipline =>
        defaultDisciplineIds.includes(discipline.value)
      );

      const existingDisciplines = state.selectedDisciplines || [];
      const processedDisciplines = existingDisciplines.map(discipline => {
        const isDefault = defaultDisciplineIds.includes(discipline.discipline);
        return {
          ...discipline,
          isDefault,
          serie: isDefault ? serieId : discipline.serie
        };
      });

      const missingDefaultDisciplines = defaultDisciplines
        .filter(
          defaultDisc =>
            !processedDisciplines.some(
              existingDisc => existingDisc.discipline === defaultDisc.value
            )
        )
        .map(defaultDisc => ({
          serie: serieId,
          discipline: defaultDisc.value,
          isDefault: true
        }));

      const combinedDisciplines = [
        ...processedDisciplines,
        ...missingDefaultDisciplines
      ];

      return {
        defaultDisciplines,
        selectedDisciplines: combinedDisciplines
      };
    });
  };

  addDiscipline() {
    if (!this.state.selectedSerie) {
      toastr.error("Erro", "Selecione uma série primeiro");
      return;
    }

    this.setState(state => {
      const prev = [...state.selectedDisciplines];
      prev.push({
        discipline: null,
        serie: state.selectedSerie.value,
        isDefault: false
      });
      return { selectedDisciplines: prev };
    });
  }

  removeDiscipline(index) {
    this.setState(state => {
      const disciplineToRemove = state.selectedDisciplines[index];
      if (disciplineToRemove.isDefault) {
        toastr.error(
          "Erro",
          "Não é possível remover disciplinas padrão da série"
        );
        return state;
      }

      let prev = [...state.selectedDisciplines];
      prev.splice(index, 1);
      return { selectedDisciplines: prev };
    });
  }

  changeDiscipline(index, value) {
    this.setState(state => {
      const disciplineToChange = state.selectedDisciplines[index];
      if (disciplineToChange.isDefault) {
        toastr.error(
          "Erro",
          "Não é possível alterar disciplinas padrão da série"
        );
        return state;
      }

      let prev = [...state.selectedDisciplines];
      prev[index].discipline = value;
      return { selectedDisciplines: prev };
    });
  }

  changeSerie(index, value) {
    this.setState(state => {
      let prev = [...state.selectedDisciplines];
      prev[index].serie = value;
      return { selectedDisciplines: prev };
    });
  }

  hasMultipleSeries() {
    const validDisciplines = this.state.selectedDisciplines.filter(
      item => item.serie && item.discipline
    );

    if (validDisciplines.length <= 1) {
      return false;
    }

    const uniqueSeries = new Set(validDisciplines.map(item => item.serie));
    return uniqueSeries.size > 1;
  }

  // Método para migrar usuários para a NOVA turma em TODAS as disciplinas
  migrateUsersToNewRoom = (newRoomId, roomName) => {
    // ⚡ VALIDAÇÃO EXTRA: Garantir que newRoomId existe
    if (!newRoomId) {
      console.error("❌❌❌ ERRO CRÍTICO: newRoomId é", newRoomId);
      toastr.error("Erro", "ID da nova turma não encontrado");
      this.setState({ creating: false });
      return;
    }

    const date = new Date();
    const dateStr = `${date.getFullYear()}-${`00${date.getMonth() + 1}`.slice(
      -2
    )}-${`00${date.getDate()}`.slice(-2)} ${`00${date.getHours()}`.slice(
      -2
    )}:${`00${date.getMinutes()}`.slice(-2)}:${`00${date.getSeconds()}`.slice(
      -2
    )}`;

    // Busca as disciplinas da NOVA turma criada
    axios
      .get(`${URL.api}community/room/singleView/${newRoomId}`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          const newRoomDisciplines = resp.data.data.room_discipline || [];

          // Extrai os IDs de todas as disciplinas da nova turma
          const allDisciplineIds = newRoomDisciplines.map(
            discipline => discipline.id
          );

          if (allDisciplineIds.length === 0) {
            throw new Error("Nenhuma disciplina encontrada na nova turma");
          }

          // Prepara os dados dos usuários para a NOVA turma com TODAS as disciplinas
          const usersToMigrate = this.state.roomUsers.map(user => ({
            room_id: newRoomId,
            user_id: user.user_id,
            administrator: user.administrator || false,
            start: dateStr,
            authorized: true,
            request: false,
            disciplines: allDisciplineIds // ← TODAS as disciplinas da nova turma
          }));

          // Envia os usuários para a NOVA turma com TODAS as disciplinas
          return axios.post(
            `${URL.api}community/room_user/insertMany`,
            { data: usersToMigrate },
            {
              headers: {
                Authorization: `Bearer ${this.props.user.token}`,
                "Content-Type": "application/json"
              }
            }
          );
        }
        console.error("❌ Resposta não sucedida da API");
        throw new Error(
          "Não foi possível carregar as disciplinas da nova turma"
        );
      })
      .then(
        resp => {
          toastr.success(
            "Sucesso",
            `Migração concluída! Nova turma "${roomName}" criada com ${this.state.roomUsers.length} usuários.`
          );
          this.props.history.push("/classroom/list");
          this.setState({ creating: false });
        },
        error => {
          let errorMessage =
            "Nova turma criada, mas houve falha ao migrar os usuários.";

          if (error.response?.data?.message) {
            errorMessage += ` Erro: ${error.response.data.message}`;
          } else if (error.message) {
            errorMessage += ` Erro: ${error.message}`;
          }

          toastr.error("Atenção", errorMessage);
          this.props.history.push("/classroom/list");
          this.setState({ creating: false });
        }
      )
      .catch(error => {
        toastr.error(
          "Erro",
          "Falha crítica no processo de migração de usuários"
        );
        this.props.history.push("/classroom/list");
        this.setState({ creating: false });
      });
  };

  // Função para enviar a migração
  enviar(value) {
    if (value.start && value.end) {
      this.setState({ creating: true });

      // Formata as datas
      let formattedStart = value.start;
      let formattedEnd = value.end;

      if (value.start && typeof value.start !== "string") {
        formattedStart = this.formatDate(value.start);
      }

      if (value.end && typeof value.end !== "string") {
        formattedEnd = this.formatDate(value.end);
      }

      // Cria uma NOVA turma para o próximo ano (migração)
      const obj = {
        loggedUser: this.props.user.user.id,
        name: value.name,
        type: "closed",
        group_id: this.state.group_id,
        region_id: this.state.region_id,
        school_id: this.state.school_id,
        period_id: value.period_id,
        start: `${formattedStart} 00:00:00`, // Adiciona horário
        end: `${formattedEnd} 00:00:00`, // Adiciona horário
        external_id: null,
        class: true,
        disciplines: this.state.selectedDisciplines
          .map(item => ({
            serie_id: item.serie,
            discipline_id: item.discipline
          }))
          .filter(item => item.serie_id && item.discipline_id)
      };

      // Cria a NOVA turma migrada
      axios
        .post(`${URL.api}community/room/insert`, obj, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            if (resp.data.success) {
              // ⚡⚡⚡ CORREÇÃO: A API retorna o ID diretamente no data, não em data.data
              const newRoomId = resp.data.data; // ← CORREÇÃO AQUI!

              if (!newRoomId) {
                console.error("❌ ERRO: newRoomId é undefined/null");
                toastr.error(
                  "Erro",
                  "Não foi possível obter o ID da nova turma"
                );
                this.setState({ creating: false });
                return;
              }

              // Se há usuários para migrar, insere-os na NOVA turma em TODAS as disciplinas
              if (this.state.roomUsers.length > 0) {
                this.migrateUsersToNewRoom(newRoomId, value.name);
              } else {
                this.props.history.push("/classroom/list");
                this.setState({ creating: false });
              }
            } else {
              console.error("❌ Resposta não sucedida da API");
              toastr.error("Erro", "Falha ao criar nova turma");
              this.setState({ creating: false });
            }
          },
          error => {
            console.error("❌ Erro ao criar turma:", error);
            console.error("📊 Response data:", error.response?.data);
            toastr.error("Falha", "Falha ao criar nova turma migrada");
            this.setState({ creating: false });
          }
        );
    }
  }

  formatDate(date) {
    let month = date.getMonth() + 1;
    if (month < 10) month = `0${month}`;

    let day = date.getDate();
    if (day < 10) day = `0${day}`;

    return `${date.getFullYear()}-${month}-${day}`;
  }

  handleCustomFormChange(event) {
    const { name, value } = event.target;
    this.setState(prevState => ({
      customForm: {
        ...prevState.customForm,
        [name]: value
      }
    }));
  }

  handleCustomFormSubmit(event) {
    if (event && event.preventDefault) {
      event.preventDefault();
    }

    if (
      this.customFormRef.current &&
      !this.customFormRef.current.checkValidity()
    ) {
      this.customFormRef.current.reportValidity();
      return;
    }

    const { customForm } = this.state;

    if (!customForm.name.trim()) {
      toastr.error("Erro", "Favor preencher o campo Nome");
      return;
    }

    if (!customForm.period_id) {
      toastr.error("Erro", "Favor preencher o campo Período");
      return;
    }

    if (!customForm.start) {
      toastr.error("Erro", "Favor preencher o campo Começo");
      return;
    }

    if (!customForm.end) {
      toastr.error("Erro", "Favor preencher o campo Fim");
      return;
    }

    if (new Date(customForm.start) >= new Date(customForm.end)) {
      toastr.error("Erro", "A data de fim deve ser posterior à data de início");
      return;
    }

    if (!this.state.selectedSerie) {
      toastr.error("Erro", "Favor verificar a série selecionada");
      return;
    }

    this.enviar(customForm);
  }

  toggleReviewMode() {
    this.setState(prevState => ({
      isReviewMode: !prevState.isReviewMode
    }));
  }

  removeUserFromRoom = (userRoomId, userName) => {
    if (
      !window.confirm(`Tem certeza que deseja remover ${userName} da turma?`)
    ) {
      return;
    }

    this.setState({ removingUser: userRoomId });

    // Simplesmente remove o usuário da lista local
    // A remoção definitiva será feita quando salvar a migração
    this.setState(prevState => ({
      roomUsers: prevState.roomUsers.filter(user => user.id !== userRoomId),
      removingUser: null
    }));

    toastr.success(
      "Sucesso",
      "Usuário removido da lista. A remoção definitiva será aplicada na migração."
    );
  };

  getReviewData() {
    const { customForm, migrationChanges, roomUsers } = this.state;

    const selectedGroup = this.state.optionsGroup.find(
      g => g.value === this.state.group_id
    );
    const selectedRegion = this.state.optionsRegion.find(
      r => r.value === this.state.region_id
    );
    const selectedSchool = this.state.optionsSchool.find(
      s => s.value === this.state.school_id
    );
    const selectedPeriod = this.state.optionsPeriod.find(
      p => p.value == customForm.period_id
    );

    const disciplinesWithNames = this.state.selectedDisciplines
      .map(item => {
        const serie = this.state.series.find(s => s.value === item.serie);
        const discipline = this.state.disciplines.find(
          d => d.value === item.discipline
        );
        return {
          serie: serie ? serie.label : "N/A",
          discipline: discipline ? discipline.label : "N/A",
          serie_id: item.serie,
          discipline_id: item.discipline,
          isDefault: item.isDefault || false
        };
      })
      .filter(item => item.serie_id && item.discipline_id);

    return {
      basic: {
        name: customForm.name,
        period: selectedPeriod ? selectedPeriod.name : "N/A",
        start: customForm.start,
        end: customForm.end,
        type: "closed",
        class: true
      },
      location: {
        group: selectedGroup ? selectedGroup.name : "N/A",
        region: selectedRegion ? selectedRegion.name : "N/A",
        school: selectedSchool ? selectedSchool.name : "N/A"
      },
      disciplines: disciplinesWithNames,
      migration: migrationChanges,
      selectedSerie: this.state.selectedSerie
        ? this.state.selectedSerie.label
        : "N/A",
      users: {
        total: roomUsers.length,
        list: roomUsers.map(user => ({
          name: user.user_name,
          email: user.user_email,
          role: user.role_name
        }))
      }
    };
  }

  renderMigrationInfo() {
    const { migrationChanges, originalRoom } = this.state;

    // Obtém o ano atual
    const currentYear = new Date().getFullYear();

    // Determina a regra aplicada
    let ruleExplanation = "";
    if (
      migrationChanges.originalYear >= 2023 &&
      migrationChanges.originalYear <= 2025
    ) {
      ruleExplanation = `Turma de ${migrationChanges.originalYear} migrada para ${currentYear} (ano atual)`;
    } else if (migrationChanges.originalYear === currentYear) {
      ruleExplanation = `Turma de ${currentYear} migrada para ${
        currentYear + 1
      } (próximo ano)`;
    } else if (migrationChanges.originalYear < 2023) {
      ruleExplanation = `Turma antiga (${migrationChanges.originalYear}) migrada para ${currentYear} (ano atual)`;
    } else {
      ruleExplanation = `Turma futura migrada para ${migrationChanges.newYear}`;
    }

    return (
      <CAlert color="info">
        <h6>Informações da Migração</h6>
        <div className="mt-2">
          <strong>Turma original:</strong> {originalRoom?.name}
          <br />
          <strong>Ano original:</strong> {migrationChanges.originalYear}
          <br />
          <strong>Novo ano:</strong> {migrationChanges.newYear}
          <br />
          <strong>Série original:</strong>{" "}
          {migrationChanges.originalSeries.join(", ")}
          <br />
          <strong>Nova série:</strong>{" "}
          {migrationChanges.migratedSeries.join(", ")}
          <br />
          <strong>Regra aplicada:</strong> {ruleExplanation}
        </div>
      </CAlert>
    );
  }

  renderDisciplinesSection() {
    const { selectedSerie, selectedDisciplines, disciplines, series } =
      this.state;

    return (
      <CFormGroup>
        <CLabel className="d-block">Série e Disciplinas</CLabel>

        <CFormGroup>
          <CLabel>Série *</CLabel>
          <CInputGroup className="mb-3">
            <CInputGroupPrepend>
              <CInputGroupText>
                <i className="fa fa-graduation-cap"></i>
              </CInputGroupText>
            </CInputGroupPrepend>
            <Select
              placeholder="Série"
              options={series}
              value={selectedSerie}
              onChange={this.handleSerieChange}
              classNamePrefix="select"
              isDisabled={this.state.creating}
            />
          </CInputGroup>
        </CFormGroup>

        {selectedSerie && (
          <CFormGroup>
            <CLabel>
              Disciplinas Padrão
              <CBadge color="info" className="ml-2">
                Não editável
              </CBadge>
            </CLabel>
            <div className="mb-3">
              {selectedDisciplines
                .filter(item => item.isDefault)
                .map((item, index) => {
                  const discipline = disciplines.find(
                    d => d.value === item.discipline
                  );
                  return (
                    <CBadge
                      key={`default-${index}`}
                      color="secondary"
                      className="mr-2 mb-2 p-2"
                      style={{ fontSize: "0.9em" }}
                    >
                      <i className="fa fa-lock mr-1"></i>
                      {discipline
                        ? discipline.label
                        : "Disciplina não encontrada"}
                    </CBadge>
                  );
                })}

              {selectedDisciplines.filter(item => item.isDefault).length ===
                0 && (
                <div className="text-muted small">
                  Nenhuma disciplina padrão definida para esta série
                </div>
              )}
            </div>
          </CFormGroup>
        )}

        {selectedSerie && (
          <CFormGroup>
            <CLabel>Disciplinas Adicionais</CLabel>
            {selectedDisciplines
              .filter(item => !item.isDefault)
              .map((item, index) => {
                const realIndex = selectedDisciplines.findIndex(
                  disc => disc === item
                );

                return (
                  <CRow key={`additional-${realIndex}`} className="mb-3">
                    <CCol>
                      <CInputGroup className="input-prepend">
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-book"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <Select
                          placeholder="Disciplina Adicional"
                          options={disciplines.filter(
                            d =>
                              !selectedDisciplines.some(
                                sd => sd.discipline === d.value && sd.isDefault
                              )
                          )}
                          value={disciplines.find(
                            option => option.value === item.discipline
                          )}
                          classNamePrefix="select"
                          onChange={e =>
                            this.changeDiscipline(realIndex, e.value)
                          }
                          isDisabled={this.state.creating}
                        />
                      </CInputGroup>
                    </CCol>
                    <CCol xs="auto">
                      <CButton
                        variant="outline"
                        color="danger"
                        onClick={() => this.removeDiscipline(realIndex)}
                        disabled={this.state.creating}
                      >
                        <i className="fa fa-trash"></i>
                      </CButton>
                    </CCol>
                  </CRow>
                );
              })}

            <div className="d-flex align-items-center">
              <CButton
                variant="outline"
                color="primary"
                onClick={() => this.addDiscipline()}
                disabled={!selectedSerie || this.state.creating}
              >
                <i className="fa fa-plus mr-2"></i>
                Adicionar Disciplina
              </CButton>

              {this.hasMultipleSeries() && (
                <span className="text-warning ml-3">
                  <i className="fa fa-exclamation-triangle mr-1"></i>
                  Atenção: Disciplinas de séries diferentes selecionadas
                </span>
              )}
            </div>
          </CFormGroup>
        )}
      </CFormGroup>
    );
  }

  renderReviewScreen() {
    const reviewData = this.getReviewData();

    return (
      <div>
        <h5 className="mb-4">Revisão da Migração</h5>

        {this.renderMigrationInfo()}

        <CCard className="mb-3">
          <CCardHeader>
            <h6 className="mb-0">Informações da Turma</h6>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md="6">
                <strong>Nome:</strong> {reviewData.basic.name}
              </CCol>
              <CCol md="6">
                <strong>Período:</strong> {reviewData.basic.period}
              </CCol>
            </CRow>
            <CRow className="mt-2">
              <CCol md="6">
                <strong>Data de Início:</strong> {reviewData.basic.start}
              </CCol>
              <CCol md="6">
                <strong>Data de Fim:</strong> {reviewData.basic.end}
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <CCard className="mb-3">
          <CCardHeader>
            <h6 className="mb-0">Localização</h6>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md="4">
                <strong>Grupo:</strong> {reviewData.location.group}
              </CCol>
              <CCol md="4">
                <strong>Regional:</strong> {reviewData.location.region}
              </CCol>
              <CCol md="4">
                <strong>Escola:</strong> {reviewData.location.school}
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <CCard className="mb-3">
          <CCardHeader>
            <h6 className="mb-0">Série Migrada</h6>
          </CCardHeader>
          <CCardBody>
            <strong>Nova Série:</strong> {reviewData.selectedSerie}
          </CCardBody>
        </CCard>

        <CCard className="mb-3">
          <CCardHeader className="d-flex align-items-center">
            <h6 className="mb-0">
              Disciplinas ({reviewData.disciplines.length})
            </h6>
            {this.hasMultipleSeries() && (
              <span className="text-warning ml-3">
                <i className="fa fa-exclamation-triangle mr-1"></i>
                Atenção: Disciplinas de séries diferentes selecionadas
              </span>
            )}
          </CCardHeader>
          <CCardBody>
            {reviewData.disciplines.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Tipo</th>
                      <th>Disciplina</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reviewData.disciplines.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {item.isDefault ? (
                            <CBadge color="secondary">
                              <i className="fa fa-lock mr-1"></i>
                              Padrão
                            </CBadge>
                          ) : (
                            <CBadge color="primary">
                              <i className="fa fa-plus mr-1"></i>
                              Adicional
                            </CBadge>
                          )}
                        </td>
                        <td>{item.discipline}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-muted">Nenhuma disciplina selecionada</p>
            )}
          </CCardBody>
          <CCard className="mb-3">
            <CCardHeader>
              <h6 className="mb-0">
                Usuários para Migração ({reviewData.users.total})
              </h6>
            </CCardHeader>
            <CCardBody>
              {reviewData.users.total > 0 ? (
                <div className="table-responsive">
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th>Email</th>
                        <th>Perfil</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reviewData.users.list.map((user, index) => (
                        <tr key={index}>
                          <td>{user.name}</td>
                          <td>{user.email}</td>
                          <td>
                            <CBadge color="info">{user.role}</CBadge>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-muted">Nenhum usuário será migrado</p>
              )}
              <div className="mt-2">
                <small className="text-muted">
                  <i className="fa fa-info-circle mr-1"></i>
                  Apenas os usuários que permanecem na turma serão migrados
                </small>
              </div>
            </CCardBody>
          </CCard>
        </CCard>

        <div className="mt-4">
          <CButton
            color="secondary"
            className="mr-2"
            onClick={() => this.toggleReviewMode()}
          >
            <i className="fa fa-arrow-left mr-2"></i>
            Voltar para Edição
          </CButton>
        </div>
      </div>
    );
  }

  // Adicione após os métodos de renderização existentes
  renderRoomUsersList() {
    const { roomUsers, loadingUsers, removingUser, loading } = this.state;
    // Não mostra a seção se ainda estiver carregando os dados principais
    if (loading) {
      return null;
    }

    // Se loadingUsers for true (mas não deveria mais acontecer) ou roomUsers for null
    if (loadingUsers || roomUsers === null) {
      return (
        <div className="text-center p-4">
          <CSpinner />
          <div className="mt-2">Carregando usuários...</div>
        </div>
      );
    }

    return (
      <CCard className="mt-4">
        <CCardHeader>
          <h5 className="mb-0">
            <i className="fa fa-users mr-2"></i>
            Usuários Enturmados ({roomUsers.length})
          </h5>
        </CCardHeader>
        <CCardBody>
          {roomUsers.length === 0 ? (
            <div className="text-center text-muted p-4">
              <i className="fa fa-users fa-2x mb-2"></i>
              <div>Nenhum usuário enturmado</div>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Email</th>
                    <th>Perfil</th>
                    <th>Data de Entrada</th>
                    <th width="120">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {roomUsers.map(user => (
                    <tr key={user.id}>
                      <td>
                        <strong>{user.user_name}</strong>
                      </td>
                      <td>{user.user_email}</td>
                      <td>
                        <CBadge color="info">
                          {user.role_name || "Usuário"}
                        </CBadge>
                      </td>
                      <td>
                        {new Date(user.start).toLocaleDateString("pt-BR")}
                      </td>
                      <td>
                        <CButton
                          size="sm"
                          color="danger"
                          onClick={() =>
                            this.removeUserFromRoom(user.id, user.user_name)
                          }
                          disabled={removingUser === user.id}
                        >
                          {removingUser === user.id ? (
                            <CSpinner size="sm" color="white" />
                          ) : (
                            <>
                              <i className="fa fa-trash mr-1"></i>
                              Remover
                            </>
                          )}
                        </CButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <CAlert color="info" className="mt-3">
            <small>
              <i className="fa fa-info-circle mr-1"></i>
              Usuários removidos aqui não farão mais parte desta turma. Apenas
              os usuários que permanecerem serão migrados junto com a turma.
            </small>
          </CAlert>
        </CCardBody>
      </CCard>
    );
  }

  // Após componentDidMount, adicione estes métodos:

  // Método auxiliar para determinar o ano de destino
  getTargetMigrationYear(originalYear) {
    const currentYear = new Date().getFullYear();

    if (originalYear < currentYear) {
      // Turmas de anos anteriores migram para o ano atual
      return currentYear;
    }
    if (originalYear === currentYear) {
      // Turmas do ano atual migram para o próximo ano
      return currentYear + 1;
    }
    // Turmas de anos futuros migram para o ano seguinte delas
    return originalYear + 1;
  }

  // Método para descrever a regra de migração
  getMigrationRuleDescription(originalYear, targetYear) {
    const currentYear = new Date().getFullYear();

    if (originalYear < currentYear) {
      return `Turma de ${originalYear} migrada para ${currentYear} (ano atual)`;
    }
    if (originalYear === currentYear) {
      return `Turma de ${currentYear} migrada para ${
        currentYear + 1
      } (próximo ano)`;
    }
    return `Turma futura (${originalYear}) migrada para ${targetYear}`;
  }

  render() {
    if (this.state.loading) {
      return (
        <>
          <Breadcrumb
            current={this.props.currentRoute}
            items={[{ path: "/classroom/list", to: "/classroom/list" }]}
          />
          <Loading top="45" left="50" />
        </>
      );
    }

    if (!this.state.originalRoom) {
      return (
        <>
          <Breadcrumb
            current={this.props.currentRoute}
            items={[{ path: "/classroom/list", to: "/classroom/list" }]}
          />
          <CCard>
            <CCardBody>
              <CAlert color="danger">
                Não foi possível carregar os dados da turma para migração.
              </CAlert>
            </CCardBody>
          </CCard>
        </>
      );
    }

    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/classroom/list", to: "/classroom/list" }]}
        />
        <Prompt
          when={!this.state.creating}
          message="Os dados do formulário ainda não foram salvos. Tem certeza de que deseja sair desta página?"
        />

        <CCard>
          <CCardHeader className="d-flex align-items-center">
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <h4 className="card-title mb-1">Migrar Turma</h4>
              <div className="small text-muted">
                Atualize a turma "{this.state.originalRoom.name}" para o próximo
                ano letivo
              </div>
            </div>
            <CButton
              color="primary"
              className="d-flex justify-content-center align-items-center"
              onClick={() => {
                if (this.state.isReviewMode) {
                  this.handleCustomFormSubmit({ preventDefault: () => {} });
                } else {
                  if (
                    this.customFormRef.current &&
                    !this.customFormRef.current.checkValidity()
                  ) {
                    this.customFormRef.current.reportValidity();
                    return;
                  }

                  const { customForm } = this.state;
                  if (!customForm.name.trim()) {
                    toastr.error("Erro", "Favor preencher o campo Nome");
                    return;
                  }
                  if (!customForm.period_id) {
                    toastr.error("Erro", "Favor preencher o campo Período");
                    return;
                  }
                  if (!customForm.start) {
                    toastr.error("Erro", "Favor preencher o campo Começo");
                    return;
                  }
                  if (!customForm.end) {
                    toastr.error("Erro", "Favor preencher o campo Fim");
                    return;
                  }
                  if (new Date(customForm.start) >= new Date(customForm.end)) {
                    toastr.error(
                      "Erro",
                      "A data de fim deve ser posterior à data de início"
                    );
                    return;
                  }
                  if (!this.state.selectedSerie) {
                    toastr.error("Erro", "Favor verificar a série selecionada");
                    return;
                  }

                  this.toggleReviewMode();
                }
              }}
              disabled={this.state.creating}
            >
              <>
                <span style={this.state.creating ? { opacity: 0 } : null}>
                  <i
                    className={`fa ${
                      this.state.isReviewMode ? "fa-cloud-upload" : "fa-eye"
                    } mr-2`}
                  ></i>
                  {this.state.isReviewMode ? "Atualizar Turma" : "Revisar"}
                </span>
                {this.state.creating && (
                  <CSpinner
                    size="sm"
                    color="white"
                    style={{ position: "absolute" }}
                  />
                )}
              </>
            </CButton>
          </CCardHeader>
          <CCardBody>
            {this.state.isReviewMode ? (
              this.renderReviewScreen()
            ) : (
              <>
                {this.renderMigrationInfo()}

                <form
                  ref={this.customFormRef}
                  onSubmit={this.handleCustomFormSubmit.bind(this)}
                >
                  <CFormGroup>
                    <CLabel>Nome da Turma *</CLabel>
                    <CInputGroup>
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-text-width"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        type="text"
                        name="name"
                        value={this.state.customForm?.name || ""}
                        onChange={this.handleCustomFormChange.bind(this)}
                        placeholder="Nome da turma migrada"
                        required
                        disabled={this.state.creating}
                      />
                    </CInputGroup>

                    {/* Aviso sobre o nome da turma */}
                    <CAlert
                      color="warning"
                      className="mt-2"
                      style={{
                        borderLeft: "4px solid #ffc107",
                        backgroundColor: "#fff8e1",
                        fontSize: "0.9rem"
                      }}
                      dismissible
                    >
                      <div className="d-flex align-items-center">
                        <i
                          className="fa fa-exclamation-triangle mr-2"
                          style={{ fontSize: "1.2rem" }}
                        ></i>
                        <strong>Atenção:</strong>
                      </div>
                      <div className="mt-1">
                        Confira se o nome da turma ainda corresponde à nova
                        série. Em muitos casos, o nome da turma inclui a série e
                        o ano — por exemplo: <em>"6º A - 2024"</em> deve ser
                        atualizado para <em>"7º A - 2025"</em>.
                      </div>
                    </CAlert>
                  </CFormGroup>

                  <CFormGroup>
                    <CLabel>Período *</CLabel>
                    <CInputGroup>
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-text-width"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CSelect
                        name="period_id"
                        value={this.state.customForm?.period_id || ""}
                        onChange={this.handleCustomFormChange.bind(this)}
                        required
                        disabled={this.state.creating}
                      >
                        <option value="">Selecione um período</option>
                        {this.state.optionsPeriod.map(period => (
                          <option key={period.value} value={period.value}>
                            {period.name}
                          </option>
                        ))}
                      </CSelect>
                    </CInputGroup>
                  </CFormGroup>

                  <CRow>
                    <CCol xs="12" md="6">
                      <CFormGroup>
                        <CLabel>Início do Ano Letivo *</CLabel>
                        <CInputGroup>
                          <CInputGroupPrepend>
                            <CInputGroupText>
                              <i className="fa fa-calendar-o"></i>
                            </CInputGroupText>
                          </CInputGroupPrepend>
                          <CInput
                            type="date"
                            name="start"
                            value={this.state.customForm?.start || ""}
                            onChange={this.handleCustomFormChange.bind(this)}
                            required
                            disabled={this.state.creating}
                          />
                        </CInputGroup>
                      </CFormGroup>
                    </CCol>
                    <CCol xs="12" md="6">
                      <CFormGroup>
                        <CLabel>Fim do Ano Letivo *</CLabel>
                        <CInputGroup>
                          <CInputGroupPrepend>
                            <CInputGroupText>
                              <i className="fa fa-calendar-o"></i>
                            </CInputGroupText>
                          </CInputGroupPrepend>
                          <CInput
                            type="date"
                            name="end"
                            value={this.state.customForm?.end || ""}
                            onChange={this.handleCustomFormChange.bind(this)}
                            required
                            disabled={this.state.creating}
                          />
                        </CInputGroup>
                      </CFormGroup>
                    </CCol>
                  </CRow>
                </form>

                {/* Campos de grupo, regional e escola (mantidos da criação) */}
                {["G"].includes(this.props.general.active_roles.type) && (
                  <CFormGroup>
                    <CLabel>Grupo</CLabel>
                    <CInputGroup>
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-group"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CSelect
                        className="flex-1"
                        value={this.state.group_id}
                        onChange={e =>
                          this.setState({
                            group_id: parseInt(e.target.value),
                            region_id: null,
                            school_id: null
                          })
                        }
                        disabled={this.state.creating}
                      >
                        <option value={null}>Grupo</option>
                        {this.state.optionsGroup.map(group => (
                          <option key={group.value} value={group.value}>
                            {group.name}
                          </option>
                        ))}
                      </CSelect>
                    </CInputGroup>
                  </CFormGroup>
                )}

                {["G", "U"].includes(this.props.general.active_roles.type) && (
                  <CFormGroup>
                    <CLabel>Regional</CLabel>
                    <CInputGroup>
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-group"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CSelect
                        className="flex-1"
                        value={this.state.region_id}
                        onChange={e =>
                          this.setState({
                            region_id: parseInt(e.target.value),
                            school_id: null
                          })
                        }
                        disabled={this.state.creating}
                      >
                        <option value={null}>Regional</option>
                        {this.state.optionsRegion
                          .filter(
                            region => region.group_id === this.state.group_id
                          )
                          .map(region => (
                            <option key={region.value} value={region.value}>
                              {region.name}
                            </option>
                          ))}
                      </CSelect>
                    </CInputGroup>
                  </CFormGroup>
                )}

                {["G", "U", "R"].includes(
                  this.props.general.active_roles.type
                ) && (
                  <CFormGroup>
                    <CLabel>Escola</CLabel>
                    <CInputGroup>
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-group"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CSelect
                        className="flex-1"
                        value={this.state.school_id}
                        onChange={e =>
                          this.setState({
                            school_id: parseInt(e.target.value)
                          })
                        }
                        disabled={this.state.creating}
                      >
                        <option value={null}>Escola</option>
                        {this.state.optionsSchool
                          .filter(
                            school => school.region_id === this.state.region_id
                          )
                          .map(school => (
                            <option key={school.value} value={school.value}>
                              {school.name}
                            </option>
                          ))}
                      </CSelect>
                    </CInputGroup>
                  </CFormGroup>
                )}

                {this.renderDisciplinesSection()}
                {this.renderRoomUsersList()}
              </>
            )}
          </CCardBody>
        </CCard>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassroomMigration);
